import { colors } from '@/lib/analytics/colors';
import { SIZE_25 } from '@/lib/gridElements/size';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const avgViewsPerVideoConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.youtube.avg_views_per_video',
    id: 'average_views_per_video',
    tooltip: 'kpi.youtube.tooltip_avg_views_per_video',
    icon: {
        name: 'videos',
        style: colors.aquablue
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    orientation: ORIENTATION_VERTICAL,
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    type: 'kpi',
    mergedData: true,
    element: KPIDefault,
    loader: DefaultLoader
};
